import React from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Container, Paper, Box, Button } from "@mui/material";
import { Email, LinkedIn } from "@mui/icons-material";
import "../../styles/components/CTASection.css";

function CTASection() {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate("/contact");
  };

  return (
    <Container sx={{ py: 8 }}>
      <Paper
        className="home-cta-panel"
        elevation={3}
        sx={{
          p: 6,
          textAlign: "center",
          background:
            "linear-gradient(135deg, #001735 0%, #0066CC 56%, #008CFF 100%)",
          color: "white",
          borderRadius: 2,
        }}
      >
        <Typography variant="h4" component="h2" gutterBottom>
          Start Your Project
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, opacity: 0.9 }}>
          Let's discuss how I can help bring your vision to life.
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Button
            className="cta-button"
            variant="contained"
            size="large"
            startIcon={<Email />}
            onClick={handleContactClick}
            sx={{
              backgroundColor: "rgba(255,255,255,0.2)",
              color: "white",
              border: "2px solid rgba(255,255,255,0.3)",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.3)",
              },
            }}
          >
            Contact Me
          </Button>
          <Button
            className="cta-button"
            variant="outlined"
            size="large"
            startIcon={<LinkedIn />}
            component="a"
            href="https://www.linkedin.com/in/coryevansmith/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "white",
              borderColor: "rgba(255,255,255,0.5)",
              "&:hover": {
                borderColor: "white",
                backgroundColor: "rgba(255,255,255,0.1)",
              },
            }}
          >
            Connect on LinkedIn
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}

export default CTASection;
